const calcTotalGasInGwei = (
  { gasAmount, gasPrice }: { gasAmount: number; gasPrice: string },
  percent = 25,
) => {
  const extraGasAmount = (gasAmount / 100) * percent;
  const parsedGasAmount = parseInt((gasAmount + extraGasAmount).toString());

  return BigInt(parsedGasAmount) * BigInt(gasPrice);
};

export default calcTotalGasInGwei;
